import React from 'react';
import Axios from 'axios';
import moment from 'moment';

class AdminPubEvents extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			pubEvents: [],
			pubCompiledEvents: {
				all: [],
				typeA: [],
				typeB: []
			},
			dateA: moment(new Date()).subtract(1, 'months').format("YYYY-MM-DD"),
			dateB: moment(new Date()).format("YYYY-MM-DD"),
		};
	
		this.loadEventsCompilation = this.loadEventsCompilation.bind(this);
		this.handleDateAChange = this.handleDateAChange.bind(this);
		this.handleDateBChange = this.handleDateBChange.bind(this);
		this.dispCompiledEventsA = this.dispCompiledEventsA.bind(this);
		this.dispCompiledEventsB = this.dispCompiledEventsB.bind(this);
		this.dispAllEventsList = this.dispAllEventsList.bind(this);
		this.createEventsRowCompiledA = this.createEventsRowCompiledA.bind(this);
		this.createEventsRowCompiledB = this.createEventsRowCompiledB.bind(this);
		this.createEventsRowList = this.createEventsRowList.bind(this);
	}

	componentDidMount() {
		this.loadEventsCompilation(this.state.dateA, this.state.dateB);
	}

	loadEventsCompilation(dateA, dateB) {
		var _this = this;
		Axios.get('/api/pubEvents/compilation/dateA/' + dateA + '/dateB/' + dateB).then(function(response) {
			_this.setState({
				pubCompiledEvents: response.data
			});
		});
	}

	render() {
		//console.log('AdminPubEvents: render');
		return (
			<div className="animated fadeIn">
				<div className="row">
					<div className="col-md-2">
					<span className="small"><strong> Début de la période </strong></span><br/>
					<input className="form-control form-control-sm input-sm" type="date" id="dateA" 
						value={this.state.dateA} 
						onChange={this.handleDateAChange}></input>
					</div>

					<div className="col-md-2">
					<span className="small"><strong> Fin de la période </strong></span><br/>
					<input className="form-control form-control-sm input-sm" type="date" id="dateB" 
						value={this.state.dateB} 
						onChange={this.handleDateBChange}></input>
					</div>

					<div className="col-md-4">
						<span className="small"><strong> Shown total count </strong></span><br/>
						<span className="small"> {this.state.pubCompiledEvents.all.length} </span>
					</div>

				</div>
				<br/>

				{this.dispCompiledEventsA()}
				{this.dispCompiledEventsB()}
				{/*this.dispAllEventsList()*/}
			</div>
		);
	}

	handleDateAChange(e) {
		var dateA = e.target.value;
		this.setState({ dateA: dateA});
		this.loadEventsCompilation(dateA, this.state.dateB);
	}

	handleDateBChange(e) {
		var dateB = e.target.value;
		this.setState({ dateB: dateB});
		this.loadEventsCompilation(this.state.dateA, dateB);
	}

	dispCompiledEventsA() {
		return (
			<div className="row">
			<div className="col-md-12">

				<h5>Événements Publicités Compilés - Pages</h5>
				<div className="table-responsive">
					<table className="table table-striped table-hover table-sm">
					<tbody>
						<tr>
							<th>Customer</th>
							<th>Page</th>
							<th>Shown Count</th>
							<th>Shown %</th>
							<th>Clicked Count</th>
							<th>Clicked %</th>
						</tr>
						{this.state.pubCompiledEvents.typeA.map(this.createEventsRowCompiledA)}
					</tbody>
					</table>
				</div>
			</div>
			</div>
		);
	}

	createEventsRowCompiledA(pubEvent, peidx) {
		return (
			<tr key={'tr.uecomp.' + peidx}>
				<td>{pubEvent.custId}</td>
				<td>{pubEvent.page}</td>
				<td>{pubEvent.shownCount}</td>
				<td>{pubEvent.shownPct.toFixed(1)}</td>
				<td>{pubEvent.clickedCount}</td>
				<td>{pubEvent.clickedPct.toFixed(1)}</td>
		   </tr>
		);
	}

  dispCompiledEventsB() {
		return (
			<div className="row">
			<div className="col-md-12">

				<h5>Événements Publicités Compilés - Seasons</h5>
				<div className="table-responsive">
					<table className="table table-striped table-hover table-sm">
					<tbody>
						<tr>
							<th>Customer</th>
							<th>Season</th>
							<th>Shown Count</th>
							<th>Shown %</th>
							<th>Clicked Count</th>
							<th>Clicked %</th>
						</tr>
						{this.state.pubCompiledEvents.typeB.map(this.createEventsRowCompiledB)}
					</tbody>
					</table>
				</div>
			</div>
			</div>
		);
	}

	createEventsRowCompiledB(pubEvent, peidx) {
		return (
			<tr key={'tr.uecomp.' + peidx}>
				<td>{pubEvent.custId}</td>
				<td>{pubEvent.seasonName}</td>
				<td>{pubEvent.shownCount}</td>
				<td>{pubEvent.shownPct.toFixed(1)}</td>
				<td>{pubEvent.clickedCount}</td>
				<td>{pubEvent.clickedPct.toFixed(1)}</td>
		   </tr>
		);
	}

	dispAllEventsList() {
		return (
			<div className="row">
			<div className="col-md-12">
				<h5>Événements Publicités</h5>
				<div className="table-responsive">
					<table className="table table-striped table-hover table-sm">
					<tbody>
						<tr>
							<th>Date</th>
							<th>Description</th>
							<th>Page</th>
							<th>Season</th>
							<th>Customer Id</th>
							<th>Customer Pub Description</th>
						</tr>
						{this.state.pubCompiledEvents.all.map(this.createEventsRowList)}
					</tbody>
					</table>
				</div>
			</div>
			</div>
		);
	}

	createEventsRowList(pubEvent, peidx) {
		return (
			<tr key={'tr.ueall.' + peidx}>
				<td>{moment(pubEvent.date).format("YYYY-MM-DD HH:mm:ss")}</td>
				<td>{pubEvent.desc}</td>
				<td>{pubEvent.page}</td>
				<td>{pubEvent.seasonName}</td>
				<td>{pubEvent.custId}</td>
				<td>{pubEvent.custPdesc}</td>
		   </tr>
		);
	}

};

export default AdminPubEvents;